import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

type IndexRowItemStyleProps = {
  disabled?: boolean;
};

const indexRowItemStyle = ({ disabled }: IndexRowItemStyleProps) => [
  css`
    padding: ${theme.spacing(1)};
    display: flex;
    min-height: 40px;
    width: 100%;
    background: ${theme.colors.white};
    align-items: center;
    border: 1px solid ${theme.colors.neutral20};
    transition: background 0.2s ease;
    text-decoration: none;
    color: ${theme.colors.neutral70};
    &:not(:first-child) {
      border-top: none;
    }

    &:first-child {
      border-radius: ${theme.borderRadius.small} ${theme.borderRadius.small} 0 0;
    }

    &:last-child {
      border-radius: 0 0 ${theme.borderRadius.small} ${theme.borderRadius.small};
    }

    &:only-child {
      border-radius: ${theme.borderRadius.small};
    }
  `,
  disabled &&
    css`
      background: ${theme.colors.neutral10};
      cursor: default;
    `,
  !disabled &&
    css`
      :hover {
        background-color: ${theme.colors.neutral5};
      }
    `,
];

export const IndexRowStyles = {
  rowItem: (props: IndexRowItemStyleProps) => indexRowItemStyle(props),
};
